import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	["Template 12 - Claim Records"],
	[
		"Company Code",
		"VHIS Certification No.",
		"Claim Number",
		"Data Extraction Date (YYYYMMDD)",
		"Policy Number",
		"Admission Date (YYYYMMDD)",
		"Payment Date (YYYYMMDD)",
		"Healthcare Facility Code",
		"Actual LOA Utilised by Claimant",
		"Ind_involuntaryupgrade",
		"Ind_voluntaryupgrade",
		"Voluntaryupgrade_adjfactor",
		"Days of hospitalisation",
		"B_Sur_Fee",
		"P_Sur_Fee",
		"B_R&B",
		"P_R&B",
		"B_Phys_Fee",
		"P_Phys_Fee",
		"B_Hosp_Exp",
		"P_Hosp_Exp",
		"B_Anes_Fee",
		"P_Anes_Fee",
		"B_Theatre",
		"P_Theatre",
		"B_Spec",
		"P_Spec",
		"B_IC",
		"P_IC",
		"B_ADIT",
		"P_ADIT",
		"B_Cancer",
		"P_Cancer",
		"B_Pre_Post",
		"P_Pre_Post",
		"B_Psyc",
		"P_Psyc",
		"B_KD",
		"P_KD",
		"B_Home_Nur",
		"P_Home_Nur",
		"B_Comp_Bed",
		"P_Comp_Bed",
		"B_SMM",
		"P_SMM",
		"B_none of above",
		"P_none of above",
		"Ind_congenital",
		"Ind_upex",
		"Upex_adjfactor",
		"Age of patient",
		"Sex of patient",
		"Diagnosis Code",
		"Operation Code",
		"Indicator for claims from secondary coverage"
	]
]

const massageClaimData = claim => {
	const facts = get(claim, "facts")
	const benefitClaims = get(claim, "benefitClaims")

	const getFact = key => {
		return facts
			.filter(item => item.type === key)
			.map(item => {
				return item?.value?.stringValue !== null
					? item?.value?.stringValue
					: item?.value?.numberValue !== null
					? item?.value?.numberValue
					: item?.value?.dateValue !== null
					? item?.value?.dateValue
					: item?.value?.booleanValue !== null
					? item?.value?.booleanValue
					: null
			})
			.toString()
	}

	const getBenefit = (key, type) => {
		let value = type === "billed" ? "billedAmount" : "approvedAmount"
		return benefitClaims
			.filter(item => item?.benefit?.typeId === key)
			.map(item => item.totalValues[value])
	}

	const getAge = policy => {
		const dateOfBirth = get(policy, "contractInsured[0].dateOfBirth", null)
		const currentYear = dayjs().year()
		const yearOfBirth = dayjs(dateOfBirth).year()
		return currentYear - yearOfBirth
	}

	const benefitTypes = [
		"medical_hospital_room_and_board",
		"medical_miscellaneous_charges",
		"medical_doctors_visit_fee",
		"medical_specialist_consultations_and_visits",
		"medical_intensive_care",
		"medical_prescribed_advanced_diagnostic_imaging_tests",
		"medical_prescribed_non_surgical_cancer_treatment",
		"medical_pre_and_post_confinement_or_day_case_procedure_outpatient_care",
		"medical_psychiatric_treatment",
		"medical_surgeons_fee",
		"medical_anaesthetists_fee",
		"medical_operating_room"
	]

	const getOtherBenefitsTotal = type => {
		let value = type === "billed" ? "billedAmount" : "approvedAmount"

		return benefitClaims
			.filter(item => {
				if (!benefitTypes.includes(item?.benefit?.typeId)) return true
			})
			.map(item => item.totalValues[value])
			.reduce((a, b) => {
				const total = a + b
				return total
			}, 0)
	}

	return {
		companyCode: getFact("companyCode"),
		vhisCertNumber: get(claim, "policy.acceptedOffer.product.productId.plan"),
		claimNumber: get(claim, "issuerNumber"), // claim.issuerNumber
		extractionDate: dayjs().format("YYYYMMDD"),
		policyNumber: get(claim, "policy.issuerNumber"),
		admissionDate:
			getFact("admissionDate") === ""
				? ""
				: dayjs(getFact("admissionDate")).format("YYYYMMDD"),
		paymentDate: claim?.transactions
			.map(item => {
				return dayjs(item.dateTime).format("YYYYMMDD")
			})
			.join(","),
		healthcareFacilityCode: get(claim, "provider.internalCode"),
		levelOfAccomodation: getFact("wardClass"),
		hasInvoluntaryUpgrade: getFact("isWardClassUpgradeInvoluntary"),
		hasVoluntaryUpgrade:
			getFact("voluntaryUpgradeAdjustmentFactor") !== "" ? true : false,
		voluntaryUpgradeAdjFactor: getFact("voluntaryUpgradeAdjustmentFactor"),
		daysOfHospitalisation: facts
			.filter(item => item.type === "hospitalStayTimespan")
			.map(item => item?.value?.numberValue.toFixed(1)),
		surgicalFeesBilled: getBenefit("medical_surgeons_fee", "billed"),
		surgicalFeesPaid: getBenefit("medical_surgeons_fee", "paid"),
		roomAndBoardBilled: getBenefit("medical_hospital_room_and_board", "billed"),
		roomAndBoardPaid: getBenefit("medical_hospital_room_and_board", "paid"),
		physicianFeesBilled: getBenefit("medical_doctors_visit_fee", "billed"),
		physicianFeesPaid: getBenefit("medical_doctors_visit_fee", "paid"),
		miscFeesBilled: getBenefit("medical_miscellaneous_charges", "billed"),
		miscFeesPaid: getBenefit("medical_miscellaneous_charges", "paid"),
		anaestheticChargesBilled: getBenefit("medical_anaesthetists_fee", "billed"),
		anaestheticChargesPaid: getBenefit("medical_anaesthetists_fee", "paid"),
		operatingTheatreFeesBilled: getBenefit("medical_operating_room", "billed"),
		operatingTheatreFeesPaid: getBenefit("medical_operating_room", "paid"),
		speciailistBilled: getBenefit(
			"medical_specialist_consultations_and_visits",
			"billed"
		),
		speciailistPaid: getBenefit(
			"medical_specialist_consultations_and_visits",
			"paid"
		),
		intensiveCareBilled: getBenefit("medical_intensive_care", "billed"),
		intensiveCarePaid: getBenefit("medical_intensive_care", "paid"),

		advDiagnosticImagingBilled: getBenefit(
			"medical_prescribed_advanced_diagnostic_imaging_tests",
			"billed"
		),
		advDiagnosticImagingPaid: getBenefit(
			"medical_prescribed_advanced_diagnostic_imaging_tests",
			"paid"
		),
		nonSurgicalCancerTreatmentBilled: getBenefit(
			"medical_prescribed_non_surgical_cancer_treatment",
			"billed"
		),
		nonSurgicalCancerTreatmentPaid: getBenefit(
			"medical_prescribed_non_surgical_cancer_treatment",
			"paid"
		),
		hospConsultationBilled: getBenefit(
			"medical_pre_and_post_confinement_or_day_case_procedure_outpatient_care",
			"billed"
		),
		hospConsultationPaid: getBenefit(
			"medical_pre_and_post_confinement_or_day_case_procedure_outpatient_care",
			"paid"
		),
		psychiatricTreatmentBilled: getBenefit(
			"medical_psychiatric_treatment",
			"billed"
		),
		psychiatricTreatmentPaid: getBenefit(
			"medical_psychiatric_treatment",
			"paid"
		),
		kidneyDialysisBilled: null,
		kidneyDialysisPaid: null,
		homeNursingBilled: null,
		homeNursingPaid: null,
		companionBedBilled: null,
		companionBedPaid: null,
		suppMajorMedicalBilled: null,
		suppMajorMedicalPaid: null,
		noneOfAboveBilled: getOtherBenefitsTotal("billed"),
		noneOfAbovePaid: getOtherBenefitsTotal("paid"),
		congenitalIllness: getFact("isCongenitalIllness"),
		hasClaimAdjFactor:
			getFact("adjustmentFactorOnUnknownPreConditions") !== null ? true : false, // facts
		claimAdjFactor: getFact("adjustmentFactorOnUnknownPreConditions"), // facts
		ageOfPatient: getAge(claim.policy),
		sexOfPatient: get(claim, "policy.contractInsured[0].gender"),
		diagnosisCode: claim?.diagnosisCodes?.map(item => item.code).join(","),
		operationCode: claim?.operationCodes?.map(item => item.code).join(","),
		isSecondaryCoverage: getFact("isSecondaryCoverage")
	}
}

const rows = payload => {
	return payload.list.map(claim => {
		return Object.values(massageClaimData(claim))
	})
}
